import classnames from 'classnames'

import Directory from '@src/quince-site-common/src/domains/Directory'
import { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'

import Link from '../link'
import { Skeleton } from '../skeleton'

import styles from './breadCrumb.module.scss'

interface BreadcrumbsProps {
  directory: Directory
  breadCrumbListClass?: string
  isNewCLPFiltersExperimentActive?: boolean
  deviceType?: string
  showLoader?: boolean
}

const Breadcrumbs = ({
  directory,
  breadCrumbListClass,
  isNewCLPFiltersExperimentActive,
  deviceType,
  showLoader,
}: BreadcrumbsProps) => {
  const getBreadcrumbItemClasses = (index: number) => {
    const isFirstPath = index === 0
    const isDesktop = deviceType === DEVICE_TYPES.DESKTOP

    const experimentClasses =
      isNewCLPFiltersExperimentActive && isDesktop
        ? classnames(styles.newCLPFiltersExperiment, isFirstPath && styles.newCLPFiltersExperimentFirstPath)
        : ''

    return classnames(styles.breadCrumbPage, experimentClasses)
  }

  if (showLoader) {
    return <Skeleton className={styles.breadCrumbLoader} />
  }

  return (
    <ol className={classnames(styles.breadCrumbList, breadCrumbListClass)}>
      {directory.paths.map((path, index) => {
        const isLastPath = index === directory.paths.length - 1

        if (isLastPath) {
          const truncatedPathDisplayName =
            path.displayName.length > 38 ? path.displayName.slice(0, 35) + '...' : path.displayName
          return (
            <li className={getBreadcrumbItemClasses(index)} key={path.route}>
              {' '}
              {truncatedPathDisplayName}
            </li>
          )
        }

        return (
          <li className={getBreadcrumbItemClasses(index)} key={`${path.route}${index}`}>
            <Link className={classnames(styles.breadCrumbLink, styles.breadCrumbButton)} href={path.route}>
              {path.displayName}
            </Link>
            <span>/</span>
          </li>
        )
      })}
    </ol>
  )
}

export default Breadcrumbs
